import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/logistica/trasportoLogisticaData.json";
import { fetchMezzoViaggio, fetchTrasporti, fetchTrattori, fetchViaggio } from "../../../features/trasporti/trasportiThunk";
import { useEffect, useState } from "react";
import { fetchGiacenze } from "../../../features/giacenze/giacenzeThunk";
import { fetchMezzi, fetchMezzo } from "../../../features/Mezzi/mezziThunk";

const TrasportoLogistica = () => {
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  const dispatch = useDispatch()
  const giacenzeData = useSelector((store) => store.giacenze.giacenze);
  const trasporti = useSelector((state) => state.trasporto?.trasporti);
  const loading = useSelector((state) => state.trasporto?.loading);

  const columns = [
    { field: "date_start", headerName: "Partenza il", width: 120 },
    { field: "partenanza_da", headerName: "Luogo di partenza", width: 442 },
    { field: "date_end", headerName: "Arrivo il", width: 178 },
    { field: "destinazione_a", headerName: "Luogo di arrivo", width: 442 },
    { field: "prodotto", headerName: "Prodotto", width: 222 },
    { field: "qta_prodotto", headerName: "Q.ta prodotto", width: 124 },
    { field: "status", headerName: "Stato", width: 158 },
    { field: "azioni", headerName: "Azioni", width: 60, sortable: false },
  ];

  const [tableRows, setTableRows] = useState([]);

  useEffect(() => {
    dispatch(fetchTrattori())
    dispatch(fetchMezzoViaggio())
    dispatch(fetchViaggio())
    dispatch(fetchGiacenze())
    dispatch(fetchMezzi())
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchTrasporti())
  },[dispatch, selectSelectedCompany])

  useEffect(() => {
    if (trasporti && trasporti.length >= 0) {
      const mappedData = trasporti.map((item) => ({
        id: item.id,
        vettore: item.vettore,
        trattore: item.trattore,
        mezzo: item.mezzo,
        date_start: item.date_start,
        date_end: item.date_end,
        ore_viaggio: item.ore_viaggio,
        partenanza_da: item.partenanza_da,
        destinazione_a: item.destinazione_a,
        tipo_viaggio: item.tipo_viaggio,
        prodotto: giacenzeData.find(it => it.id === item.giacenze_id)?.name || "N/A",
        qta_prodotto: giacenzeData.find(it => it.id === item.giacenze_id)?.displonibile || "N/A",
        status: item.status

      }))
      setTableRows(mappedData)
    }
  }, [trasporti, giacenzeData])

  return (
    <div className="pageTemplate">
      {loading ? (
        <div>Loading...</div> // You can show a loading spinner or message while fetching data
      ) : (
        <Table
          data={tableRows}
          columns={columns}
          navData={"trasportoLogistica"}
          deleteFunctions={"deleteTrasportoData"}
        />
      )}
    </div>
  );
};

export default TrasportoLogistica;
